module.exports = __webpack_public_path__ + "static/media/login-bg.8af7453c.jpeg";